<wcg-dialog [title]="dialogData.title">
  <div class="view-more-date-dialog__container" content>
    @defer (when dialogData.data) {
      @for (date of dialogData.data; track date; let isLast = $last) {
        <div
          class="view-more-date-dialog__content"
          [ngClass]="{ 'view-more-date-dialog__no-border-last': isLast }"
        >
          <span class="view-more-date-dialog__content__date">
            {{ date.review_dt | ermDateTime }}
          </span>
          <span>
            {{ date.type }}
          </span>
        </div>
      }
    }
  </div>

  <div primary>
    <button
      mat-flat-button
      mat-button
      wcg-button
      color="primary"
      mat-dialog-close
    >
      Done
    </button>
  </div>
</wcg-dialog>
